// extracted by mini-css-extract-plugin
export var checkboxesContainer = "IncommOfferForm-module--checkboxesContainer--3c64f";
export var error = "IncommOfferForm-module--error--d1f1e";
export var formContainer = "IncommOfferForm-module--formContainer--41e4c";
export var formHeader = "IncommOfferForm-module--formHeader--af5bc";
export var incommForm = "IncommOfferForm-module--incommForm--4cf3b";
export var submitButton = "IncommOfferForm-module--submitButton--06a15";